// AI: below section was generated by an AI
export const ALARM_SEVERITIES = {
  "0": { label: "Informacja", style: "info", color: "#1DC7EA" },
  "1": { label: "Ostrzeżenie", style: "warning", color: "#FFA534" },
  "2": { label: "Alarm", style: "danger", color: "#FB404B" },
  "3": { label: "Krytyczny", style: "danger", color: "#A93226" }
};

export const TANK_STATES = {
  "0": { label: "Nieustalony", style: "default", color: "#8A9AA3" },
  "1": { label: "Pusty", style: "default", color: "#65727A" },
  "2": { label: "Dój / napełnianie", style: "info", color: "#1DC7EA" },
  "3": { label: "Chłodzenie", style: "primary", color: "#3472F7" },
  "4": { label: "Magazynowanie", style: "success", color: "#6FAF16" },
  "5": { label: "Odbiór", style: "warning", color: "#FFA534" },
  "6": { label: "Mycie", style: "info", color: "#20AEB7" }
};

export function getAlarmSeverity(value) {
  const aliases = {
    info: "0",
    warning: "1",
    alarm: "2",
    critical: "3"
  };
  const raw = String(value === undefined || value === null ? "" : value)
    .toLowerCase();
  const key = aliases[raw] || raw;
  return (
    ALARM_SEVERITIES[key] || {
      label: raw || "Nieznany",
      style: "default",
      color: "#777777"
    }
  );
}

export function getTankState(value) {
  const raw =
    value === undefined || value === null ? "" : String(value);
  return (
    TANK_STATES[raw] || {
      label: raw === "" ? "Brak danych" : `Nieznany (${raw})`,
      style: "default",
      color: "#8A9AA3"
    }
  );
}

export function formatAlarmNumber(value) {
  const number = Number(value);
  return Number.isFinite(number) ? number.toFixed(2) : String(value);
}

// Rounds measurement values in the diagnostic tree without changing other
// counters and identifiers that should remain exact.
export function roundAlarmDiagnostics(value, fieldName) {
  if (Array.isArray(value))
    return value.map(item => roundAlarmDiagnostics(item, fieldName));
  if (value && typeof value === "object")
    return Object.keys(value).reduce((result, key) => {
      result[key] = roundAlarmDiagnostics(value[key], key);
      return result;
    }, {});
  const normalizedField = String(fieldName || "").toLowerCase();
  if (
    typeof value === "number" &&
    (normalizedField.indexOf("temperature") >= 0 ||
      normalizedField.indexOf("volume") >= 0)
  )
    return Number(value.toFixed(2));
  return value;
}
// AI: end



// WEBPACK FOOTER //
// ./src/utils/alarmPresentation.js